var React = require('react');

function ShoppingBag (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.03449 5.76208C2.05795 5.57442 2.21747 5.43359 2.40659 5.43359H13.9744C14.1635 5.43359 14.323 5.57442 14.3465 5.76208L15.6203 15.9526C15.6483 16.1764 15.4737 16.3741 15.2482 16.3741H1.13278C0.90722 16.3741 0.7327 16.1764 0.760678 15.9526L2.03449 5.76208Z","stroke":"black","strokeWidth":"1.25","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M5.33301 4.80952V3C5.33301 1.89543 6.22844 1 7.33301 1H9.42825C10.5328 1 11.4282 1.89543 11.4282 3V4.80952","stroke":"black","strokeWidth":"1.25","strokeLinecap":"round","key":1})]);
}

ShoppingBag.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = ShoppingBag;

ShoppingBag.default = ShoppingBag;
